<enelx-navbar [productName]="'Flex'" [url]="navbarUrl" position="left" [maxMenuElements]="0">
  <div slot="content">
    <router-outlet />
    <ngx-global-contact-footer class="footer"></ngx-global-contact-footer>
  </div>
</enelx-navbar>
